import { PURGE_DATA } from './timer';

const UPDATE_PAIRS = '@@checkout/business/update_pairs';
const UPDATE_EC_SITE = '@@checkout/business/update_ecSite';

const numberKeys = [
  'establishedYear',
  'establishedMonth',
  'capital',
  'yearlySales',
  'ecSiteCount',
  'employeeCount',
  'phone',
  'fax',

  'ecSite_1_monthlyTransactionCount',
  'ecSite_1_averagePurchaseAmount',
  'ecSite_1_yearlyRevenue',
  'ecSite_1_memberCount',
  'ecSite_1_creditCardUsage',
  'ecSite_1_creditCardFee',
  'ecSite_1_combiniUsage',
  'ecSite_1_combiniFee',
  'ecSite_1_cashUsage',
  'ecSite_1_cashFee',
  'ecSite_1_netBankUsage',
  'ecSite_1_netBankFee',
  'ecSite_1_idUsage',
  'ecSite_1_idFee',
  'ecSite_1_postPayUsage',
  'ecSite_1_postPayFee',
  'ecSite_1_othersUsage',
  'ecSite_1_othersFee',

  'ecSite_2_monthlyTransactionCount',
  'ecSite_2_averagePurchaseAmount',
  'ecSite_2_yearlyRevenue',
  'ecSite_2_memberCount',
  'ecSite_2_creditCardUsage',
  'ecSite_2_creditCardFee',
  'ecSite_2_combiniUsage',
  'ecSite_2_combiniFee',
  'ecSite_2_cashUsage',
  'ecSite_2_cashFee',
  'ecSite_2_netBankUsage',
  'ecSite_2_netBankFee',
  'ecSite_2_idUsage',
  'ecSite_2_idFee',
  'ecSite_2_postPayUsage',
  'ecSite_2_postPayFee',
  'ecSite_2_othersUsage',
  'ecSite_2_othersFee',

  'ecSite_3_monthlyTransactionCount',
  'ecSite_3_averagePurchaseAmount',
  'ecSite_3_yearlyRevenue',
  'ecSite_3_memberCount',
  'ecSite_3_creditCardUsage',
  'ecSite_3_creditCardFee',
  'ecSite_3_combiniUsage',
  'ecSite_3_combiniFee',
  'ecSite_3_cashUsage',
  'ecSite_3_cashFee',
  'ecSite_3_netBankUsage',
  'ecSite_3_netBankFee',
  'ecSite_3_idUsage',
  'ecSite_3_idFee',
  'ecSite_3_postPayUsage',
  'ecSite_3_postPayFee',
  'ecSite_3_othersUsage',
  'ecSite_3_othersFee',

  'ecSite_4_monthlyTransactionCount',
  'ecSite_4_averagePurchaseAmount',
  'ecSite_4_yearlyRevenue',
  'ecSite_4_memberCount',
  'ecSite_4_creditCardUsage',
  'ecSite_4_creditCardFee',
  'ecSite_4_combiniUsage',
  'ecSite_4_combiniFee',
  'ecSite_4_cashUsage',
  'ecSite_4_cashFee',
  'ecSite_4_netBankUsage',
  'ecSite_4_netBankFee',
  'ecSite_4_idUsage',
  'ecSite_4_idFee',
  'ecSite_4_postPayUsage',
  'ecSite_4_postPayFee',
  'ecSite_4_othersUsage',
  'ecSite_4_othersFee',

  'ecSite_5_monthlyTransactionCount',
  'ecSite_5_averagePurchaseAmount',
  'ecSite_5_yearlyRevenue',
  'ecSite_5_memberCount',
  'ecSite_5_creditCardUsage',
  'ecSite_5_creditCardFee',
  'ecSite_5_combiniUsage',
  'ecSite_5_combiniFee',
  'ecSite_5_cashUsage',
  'ecSite_5_cashFee',
  'ecSite_5_netBankUsage',
  'ecSite_5_netBankFee',
  'ecSite_5_idUsage',
  'ecSite_5_idFee',
  'ecSite_5_postPayUsage',
  'ecSite_5_postPayFee',
  'ecSite_5_othersUsage',
  'ecSite_5_othersFee',
];

export const ecSite1 = {
  ecSite_1_title: '',
  ecSite_1_url: '',
  ecSite_1_cardSystem: '',
  ecSite_1_paymentService: '',
  ecSite_1_website: '',
  ecSite_1_privacyPolicy: '',
  ecSite_1_privacyPolicyConsent: '',
  ecSite_1_productType: '',
  ecSite_1_productTypeOthers: '',
  ecSite_1_monthlyTransactionCount: '',
  ecSite_1_averagePurchaseAmount: '',
  ecSite_1_yearlyRevenue: '',
  ecSite_1_memberCount: '',
  ecSite_1_emailForPaidy: '',
  ecSite_1_categories: {},
  ecSite_1_errorCategory: '',
  ecSite_1_otherCategory: '',

  ecSite_1_creditCardUsage: '',
  ecSite_1_creditCardFee: '',
  ecSite_1_combiniUsage: '',
  ecSite_1_combiniFee: '',
  ecSite_1_cashUsage: '',
  ecSite_1_cashFee: '',
  ecSite_1_netBankUsage: '',
  ecSite_1_netBankFee: '',
  ecSite_1_idUsage: '',
  ecSite_1_idFee: '',
  ecSite_1_postPayUsage: '',
  ecSite_1_postPayFee: '',
  ecSite_1_othersPaymentMethod: '',
  ecSite_1_othersUsage: '',
  ecSite_1_othersFee: '',
  ecSite_1_searchKeyword: '',
};

export const ecSite2 = {
  ecSite_2_title: '',
  ecSite_2_url: '',
  ecSite_2_cardSystem: '',
  ecSite_2_paymentService: '',
  ecSite_2_website: '',
  ecSite_2_privacyPolicy: '',
  ecSite_2_privacyPolicyConsent: '',
  ecSite_2_productType: '',
  ecSite_2_productTypeOthers: '',
  ecSite_2_monthlyTransactionCount: '',
  ecSite_2_averagePurchaseAmount: '',
  ecSite_2_yearlyRevenue: '',
  ecSite_2_memberCount: '',
  ecSite_2_emailForPaidy: '',
  ecSite_2_categories: {},
  ecSite_2_errorCategory: '',
  ecSite_2_otherCategory: '',

  ecSite_2_creditCardUsage: '',
  ecSite_2_creditCardFee: '',
  ecSite_2_combiniUsage: '',
  ecSite_2_combiniFee: '',
  ecSite_2_cashUsage: '',
  ecSite_2_cashFee: '',
  ecSite_2_netBankUsage: '',
  ecSite_2_netBankFee: '',
  ecSite_2_idUsage: '',
  ecSite_2_idFee: '',
  ecSite_2_postPayUsage: '',
  ecSite_2_postPayFee: '',
  ecSite_2_othersPaymentMethod: '',
  ecSite_2_othersUsage: '',
  ecSite_2_othersFee: '',
  ecSite_2_searchKeyword: '',
};

export const ecSite3 = {
  ecSite_3_title: '',
  ecSite_3_url: '',
  ecSite_3_cardSystem: '',
  ecSite_3_paymentService: '',
  ecSite_3_website: '',
  ecSite_3_privacyPolicy: '',
  ecSite_3_privacyPolicyConsent: '',
  ecSite_3_productType: '',
  ecSite_3_productTypeOthers: '',
  ecSite_3_monthlyTransactionCount: '',
  ecSite_3_averagePurchaseAmount: '',
  ecSite_3_yearlyRevenue: '',
  ecSite_3_memberCount: '',
  ecSite_3_emailForPaidy: '',
  ecSite_3_categories: {},
  ecSite_3_errorCategory: '',
  ecSite_3_otherCategory: '',

  ecSite_3_creditCardUsage: '',
  ecSite_3_creditCardFee: '',
  ecSite_3_combiniUsage: '',
  ecSite_3_combiniFee: '',
  ecSite_3_cashUsage: '',
  ecSite_3_cashFee: '',
  ecSite_3_netBankUsage: '',
  ecSite_3_netBankFee: '',
  ecSite_3_idUsage: '',
  ecSite_3_idFee: '',
  ecSite_3_postPayUsage: '',
  ecSite_3_postPayFee: '',
  ecSite_3_othersPaymentMethod: '',
  ecSite_3_othersUsage: '',
  ecSite_3_othersFee: '',
  ecSite_3_searchKeyword: '',
};

export const ecSite4 = {
  ecSite_4_title: '',
  ecSite_4_url: '',
  ecSite_4_cardSystem: '',
  ecSite_4_paymentService: '',
  ecSite_4_website: '',
  ecSite_4_privacyPolicy: '',
  ecSite_4_privacyPolicyConsent: '',
  ecSite_4_productType: '',
  ecSite_4_productTypeOthers: '',
  ecSite_4_monthlyTransactionCount: '',
  ecSite_4_averagePurchaseAmount: '',
  ecSite_4_yearlyRevenue: '',
  ecSite_4_memberCount: '',
  ecSite_4_emailForPaidy: '',
  ecSite_4_categories: {},
  ecSite_4_errorCategory: '',
  ecSite_4_otherCategory: '',

  ecSite_4_creditCardUsage: '',
  ecSite_4_creditCardFee: '',
  ecSite_4_combiniUsage: '',
  ecSite_4_combiniFee: '',
  ecSite_4_cashUsage: '',
  ecSite_4_cashFee: '',
  ecSite_4_netBankUsage: '',
  ecSite_4_netBankFee: '',
  ecSite_4_idUsage: '',
  ecSite_4_idFee: '',
  ecSite_4_postPayUsage: '',
  ecSite_4_postPayFee: '',
  ecSite_4_othersPaymentMethod: '',
  ecSite_4_othersUsage: '',
  ecSite_4_othersFee: '',
  ecSite_4_searchKeyword: '',
};

export const ecSite5 = {
  ecSite_5_title: '',
  ecSite_5_url: '',
  ecSite_5_cardSystem: '',
  ecSite_5_paymentService: '',
  ecSite_5_website: '',
  ecSite_5_privacyPolicy: '',
  ecSite_5_privacyPolicyConsent: '',
  ecSite_5_productType: '',
  ecSite_5_productTypeOthers: '',
  ecSite_5_monthlyTransactionCount: '',
  ecSite_5_averagePurchaseAmount: '',
  ecSite_5_yearlyRevenue: '',
  ecSite_5_memberCount: '',
  ecSite_5_emailForPaidy: '',
  ecSite_5_categories: {},
  ecSite_5_errorCategory: '',
  ecSite_5_otherCategory: '',

  ecSite_5_creditCardUsage: '',
  ecSite_5_creditCardFee: '',
  ecSite_5_combiniUsage: '',
  ecSite_5_combiniFee: '',
  ecSite_5_cashUsage: '',
  ecSite_5_cashFee: '',
  ecSite_5_netBankUsage: '',
  ecSite_5_netBankFee: '',
  ecSite_5_idUsage: '',
  ecSite_5_idFee: '',
  ecSite_5_postPayUsage: '',
  ecSite_5_postPayFee: '',
  ecSite_5_othersPaymentMethod: '',
  ecSite_5_othersUsage: '',
  ecSite_5_othersFee: '',
  ecSite_5_searchKeyword: '',
};

const initialState = {
  dateOfBirth: '',
  dobYear: '',
  dobMonth: '',
  dobDay: '',

  establishedYear: '',
  establishedMonth: '',
  statementMonth: '',
  // capital: '',
  // yearlySales: '',
  ecSiteCount: '',
  employeeCount: '',
  phone: '',
  fax: '',
  website: '',
  membership: '',

  ...ecSite1,
  ...ecSite2,
  ...ecSite3,
  ...ecSite4,
  ...ecSite5,
};

const stringKeys = [
  'ecSite_1_searchKeyword',
  'ecSite_2_searchKeyword',
  'ecSite_3_searchKeyword',
  'ecSite_4_searchKeyword',
  'ecSite_5_searchKeyword',
];

const form = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PAIRS: {
      const newState = Object.keys(action.pairs).reduce((accu, key) => {
        const _accu = { ...accu };

        _accu[key] = action.pairs[key];

        if (stringKeys.indexOf(key) > -1) {
          // includes `undefined` and `null`
          _accu[key] = _accu[key] || '';
        }

        if (key === 'zip' || key === 'regZip') {
          // toString is to make sure unexpected input never cause issue
          _accu[key] = _accu[key].toString().replace(/\D/g, '');
        }


        if (numberKeys.indexOf(key) > -1) {
          _accu[key] = _accu[key].toString().replace(/[^\d.]/g, '');
        }

        // TODO: to enforce number fields in ecSites display only hankaku numbers
        // if (key === 'ecSites' && action.subName && numberKeys.indexOf(action.subName) > -1) {
        //   _accu[key][action.subName] = _accu[key][action.subName].toString().replace(/\D/g, '');
        // }

        return _accu;
      }, {});

      return {
        ...state,
        ...newState,
      };
    }
    /**
     * This is for reset ec site field
     */
    case UPDATE_EC_SITE: {
      const format = {};

      Object.keys(action.ecSite).forEach(key => {
        if (key.indexOf('ecSite_') === 0) {
          format[key] = action.ecSite[key];
        }
      });

      return {
        ...state,
        ...format,
      };
    }
    case PURGE_DATA: {
      return initialState;
    }
    default:
      return state;
  }
};

export const updatePairs = (pairs, subName) => {
  return {
    type: UPDATE_PAIRS,
    pairs,
    subName,
  };
};

export const updateEcSite = ecSite => {
  return {
    type: UPDATE_EC_SITE,
    ecSite,
  };
};

export default form;
